import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  minimiseState: "CLOSED_FILE_SYNC",
  data: {},
};

const fileSyncSlice = createSlice({
  name: "fileSyncState",
  initialState,
  reducers: {
    minimiseFileSync: (state) => {
      state.minimiseState = "MINIMISED_FILE_SYNC";
    },
    maximiseFileSync: (state) => {
      state.minimiseState = "MAXIMISED_FILE_SYNC";
    },
    closeFileSync: (state) => {
      state.minimiseState = "CLOSED_FILE_SYNC";
    },
    setFileSyncData: (state, action) => {
      if (state.minimiseState === "CLOSED_FILE_SYNC") {
        state.minimiseState = "MINIMISED_FILE_SYNC";
      }
      state.data = action.payload;
    },
  },
});

const fileSyncMapperSlice = createSlice({
  name: "fileSyncMapper",
  initialState: {
    project: {},
    space: {},
    hierarchyId: {},
  },
  reducers: {
    fileSyncMapperLoading: (state, action) => {
      state[action.payload.moduleName][action.payload.moduleId] = {
        isLoading: true,
        isLoaded: false,
        data: null,
      };
    },
    fileSyncMapperLoaded: (state, action) => {
      state[action.payload.moduleName][action.payload.moduleId] = {
        isLoading: false,
        isLoaded: true,
        data: action.payload.data,
      };
    },
    fileSyncMapperClear: (state, action) => {
      state[action.payload.moduleName][action.payload.moduleId] = {
        isLoading: false,
        isLoaded: false,
        data: null,
      };
    },
  },
});

export const { minimiseFileSync, maximiseFileSync, closeFileSync, setFileSyncData } = fileSyncSlice.actions;

export const { fileSyncMapperLoading, fileSyncMapperLoaded, fileSyncMapperClear } = fileSyncMapperSlice.actions;

export const fileSyncState = fileSyncSlice.reducer;
export const fileSyncMapperState = fileSyncMapperSlice.reducer;
